import { Typography } from '@mui/material'
import Dialog from 'components/dialog/dialog'

type ModalConfirmProps = {
  open: boolean
  title?: string
  text?: string
  text2?: string
  loading: boolean
  onClose?: () => void
  onSubmit?: () => void
}

const ModalConfirm = ({
  title,
  open,
  text,
  text2,
  loading = false,
  onClose,
  onSubmit
}: ModalConfirmProps) => (
  <Dialog
    title={title ?? ''}
    submitText='Yes'
    open={open}
    onCancel={onClose}
    onSubmit={onSubmit}
    loading={loading}
  >
    <Typography>Are you sure want to {text}?</Typography>
    {text2 && <Typography>{text2}</Typography>}
  </Dialog>
)

export default ModalConfirm
